module.exports = __webpack_public_path__ + "img/recordCard.d89618a1.png";